import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminBusinessActivityCategories = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITY_CATEGORIES.GET_ALL, { params });
    return response.data;
};

export const getAdminBusinessActivityCategoryById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITY_CATEGORIES.GET_BY_ID(id));
    return response.data;
};

export const createBusinessActivityCategory = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITY_CATEGORIES.CREATE, data);
    return response.data;
};

export const updateBusinessActivityCategory = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITY_CATEGORIES.UPDATE(id), data);
    return response.data;
};

export const deleteBusinessActivityCategory = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.BUSINESS_ACTIVITY_CATEGORIES.DELETE(id));
    return response.data;
};
